/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BulkMessageStatus {
    PENDING = 'Pending',
    RUNNING = 'Running',
    PAUSED = 'Paused',
    CANCELLED = 'Cancelled',
    DONE = 'Done',
}
